export const permission = 1;
export const SCREEN_NAME = 'advertising-tracker3.0';
export const FILTER_PERIOD = 'period';
export const FILTER_PAY_TO = 'payTo';
export const FILTER_GENRES = 'genreIds';
export const FILTER_RE_COUNTER_TYPES = 'reCounterFilterTypes';
export const FILTER_NETWORKS = 'networks';
export const FILTER_CLUSTERS = 'clusters';
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_CAMPAIGNS = 'campaigns';
export const FILTER_MANAGERS = 'managers';
export const FILTER_COUNTRIES = 'countries';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_OWNERS = 'ownerIds';
export const FILTER_LABELS = 'labelIds';
export const FILTER_CLIENTS = 'clientIds';
export const FILTER_INCLUDE_ARCHIVED = 'includeArchivedCampaigns';
export const FILTER_TRAFFIC_TYPE = 'trafficTypeId';
export const FILTER_TRAFFIC_TYPE_ADVERTISING = 1;
export const REGISTRATION = 0;
export const EXCLUDE_FRAUD = 1;
export const FILTER_CHANNELS = 'channels';
export const FILTER_REGISTRATION_TYPE = 'botRegistrationType';
export const FILTER_CAMPAIGNS_TYPES = 'targetingActivityTypeIds';
export const FILTER_CHANNEL_TYPE = 'channelTypes';
export const FILTER_STATUSES = 'statuses';
export const FILTER_FRAUD_TYPE = 'fraudType';
export const FILTER_DEVICE_TYPE = 'deviceTypes';
export const FILTER_CPE_LIVE_EVENT_TYPE = 'cpeLiveEventFilterType';

// InfluencerChannel
export const FILTER_BRIEFS = 'briefIds';
export const FILTER_INFLUENCER_CHANNEL_SUBSCRIBERS =
  'influencerChannelSubscriberBuckets';
export const FILTER_INFLUENCER_CHANNEL_TOTAL_VIEWS =
  'influencerChannelTotalViewBuckets';
export const FILTER_INFLUENCER_CHANNEL_PRICES = 'influencerChannelPriceBuckets';
export const FILTER_INFLUENCER_CHANNEL_SOCIAL_MEDIA_PLATFORMS =
  'influencerChannelSocialMediaPlatformIds';

export const FILTER_INFLUENCER_CHANNEL_GENDERS =
  'influencerChannelGenderBuckets';

export const FILTER_REAL_CP_FLOWS = 'realConversionPageFlowIds';
export const FILTER_REAL_COUNTRIES = 'realCountryIds';

export const FILTER_CREATIVE_CREATED_BY = 'createdBy';
export const FILTER_CREATIVE_TYPES = 'creativeTypes';
export const FILTER_CREATIVE_LANGUAGES = 'languages';
export const FILTER_CREATIVE_LENGTH = 'length';
export const FILTER_CREATIVE_MEDIA_TYPES = 'mediaTypes';
export const FILTER_CREATIVE_ORIENTATIONS = 'orientations';
export const FILTER_CREATIVE_REQUESTED_BY = 'requestedBy';
export const FILTER_CREATIVE_RESOLUTIONS = 'resolutions';
export const FILTER_CREATIVE_SIZES = 'sizes';
export const FILTER_CREATIVE_COLORS = 'colors';
export const FILTER_CREATIVE_AUTHORS = 'authors';
export const FILTER_CREATIVE_ENHANCERS = 'enhancers';
export const FILTER_CREATIVE_INCLUDED_TAGS = 'includedTags';
export const FILTER_CREATIVE_EXCLUDED_TAGS = 'excludedTags';
export const FILTER_CREATIVE_OS = 'osIds';
export const FILTER_CREATIVE_CREATION_PERIOD = 'creationPeriod';
export const FILTER_CREATIVE_CONCEPT_CREATION_PERIOD = 'conceptCreationPeriod';
export const FILTER_CREATIVE_STATUSES = 'creativeStatuses';
export const FILTER_CREATIVE_END_CARD = 'endCardTypes';
export const FILTER_CREATIVE_TESTED = 'tested';
export const FILTER_CPE_LIVE_EVENTS = 'cpeLiveEvents';

//columns
export const COLUMN_DIMENSION = 'Dimension';
export const COLUMN_TOTAL_REGS = 'TotalRegs';
export const PARTNER_COLUMNS_REGS = 'RegActions';

// date dimensions
export const DIMENSION_DAY = 'Day';
export const DIMENSION_WEEK = 'Week';
export const DIMENSION_MONTH = 'Month';
export const DIMENSION_DAY_OF_THE_WEEK = 'Weekday';
// Gallery dimensions
export const DIMENSION_CAMPAIGN = 'Campaign';
export const DIMENSION_AFFILIATE = 'Affiliate';
export const DIMENSION_END_CARD = 'EndCard';

//  creative base dimensions
export const DIMENSION_CREATIVE = 'CreativeFile';
export const DIMENSION_CONCEPT = 'Concept';
export const DIMENSION_AUTHOR = 'Author';
export const DIMENSION_LANGUAGE = 'Language';
export const DIMENSION_LENGTH = 'Length';
export const DIMENSION_MEDIA_TYPE = 'MediaType';
export const DIMENSION_ORIENTATION = 'Orientation';
export const DIMENSION_RESOLUTION = 'Resolution';
export const DIMENSION_TAG = 'CreativeFileTag';
export const DIMENSION_TAG_CATEGORY = 'TagCategory';
export const DIMENSION_CREATIVE_TYPE = 'CreativeType';
export const DIMENSION_AI_TAG = 'AiTag';
export const DIMENSION_REAL_CONVERSION_PAGE = 'RealLandingPage';

// Totals dimension

export const DIMENSION_TOTALS = 'Totals';

// metrics groups
export const PUBLIC_CUSTOM_METRIC = 11;
export const MY_CUSTOM_METRIC = 14;

export const isSystemMetric = (groupId) => {
  return ![PUBLIC_CUSTOM_METRIC, MY_CUSTOM_METRIC].includes(groupId);
};

// Gallery ids
export const STATUS_MEDIA_ARCHIVED = 1;
export const PERMISSION_ARCHIVED = 29;

//partners creative filters permission
export const PERMISSION_ID = 47;

export const FILTER_TITLES = {
  genres: 'Genres',
  networks: 'Networks',
  affiliates: 'Affiliates',
  campaigns: 'Campaigns',
  managers: 'Managers',
  countries: 'Countries',
  platforms: 'Platforms',
  applications: 'Applications',
  clusters: 'Clusters',
  owners: 'Owners',
  labels: 'Labels',
  clients: 'Clients',
  trafficType: 'Traffic type',
  channels: 'Channels',
  channelTypes: 'Channel type',
  statuses: 'Statuses (by partner entities)',
  createdBy: 'Created by',
  creativeTypes: 'Creative types',
  languages: 'Languages',
  lengths: 'Lengths (sec)',
  mediaTypes: 'Media Types',
  orientations: 'Orientations',
  requestedBy: 'Requested by',
  resolutions: 'Resolutions',
  sizes: 'Sizes',
  colors: 'Colors',
  authors: 'Authors',
  enhancers: 'Enhancers',
  includedTags: 'Included tags',
  excludedTags: 'Excluded tags',
  os: 'OS',
  creationPeriod: 'Creative added',
  conceptCreationPeriod: 'Concept added',
  realCountrys: 'Real countries',
  deviceTypes: 'Real Device type',
  realConversionPageFlows: 'CP flow',
  botRegistrationTypes: 'Registrations',
  targetingActivityTypes: 'Campaign Type',
  fraudTypes: 'Fraud',
  influencerChannelSubscriberBuckets: 'Subscribers',
  influencerChannelTotalViewBuckets: 'Total Views',
  influencerChannelPriceBuckets: 'Prices',
  influencerChannelSocialMediaPlatformIds: 'Social Media Platforms',
  influencerChannelGenderBuckets: 'Genders',
  briefs: 'Briefs',
  creativeStatuses: 'Statuses (creatives)',
  endCard: 'Included end card',
  includeArchivedCampaigns: 'Include archived',
  tested: 'Tested',
};
